const en_whs_goodsdetail = {
    label: {
        location_start: "Initial Location",
        location_final: "Final Location",

        note_convertion: "Generated from Conversion",
        note_goods: "Generated from Item",

        status_stock: "Stock Status",
    },
}

export default en_whs_goodsdetail;